var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("select-dialog", {
    attrs: {
      title: _vm.$t("CargoMsg.Cargo_SelectOperationInstruction"),
      "row-data": _vm.rowData,
      "column-defs": _vm.columnDefs,
      "filter-keys": ["chineseName"],
      value: _vm.tenantInstruction ? _vm.tenantInstruction.uuid : "",
      "event-name": _vm.eventName,
      "input-width": _vm.inputWidth,
      "display-name-field": "chineseName"
    },
    on: { change: _vm.changeTrigger }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }